const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'stretch',
    width: '100%',
    // No top padding: the course page's tabs already leave the room above.
    padding: '0 0 40px',
  },
  collectionRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'stretch',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    padding: '0px 0px 24px 0',
    flexDirection: 'column',
    alignSelf: 'stretch',
    width: '100%',
    gap: 16,
    maxWidth: '1280px',
    alignItems: 'center',
  },
  editor: {
    width: '100%',
  },
  card: {
    width: '100%',
    overflow: 'hidden',
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
  },
  // Holds the header's room while the page's own landing page loads.
  previewPlaceholder: {
    height: 440,
    background: '#F7F8FA',
  },
})

export default styles
